<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>预约管理</el-breadcrumb-item>
      <el-breadcrumb-item>预约列表</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card>
      <el-tabs v-model="tabIndex" @tab-click="handleClick">
        <el-tab-pane v-for="item in statusOptions" :key="item.id" :label="item.value"></el-tab-pane>
      </el-tabs>

      <el-row>
        
        <el-col :span="4">
          <el-input placeholder="请输入家长姓名" v-model="queryInfo.name" clearable @clear="getOrderList">
            <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
          </el-input>
          
        </el-col>
        <el-col :span="4">
          <el-input placeholder="请输入学生姓名" v-model="queryInfo.s_name" clearable @clear="getOrderList">
            <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
          </el-input>
        </el-col>

        <el-col :span="8">
          <div class="block aaaa">
            <el-date-picker
              :default-time="['00:00:00', '23:59:59']"
              v-model="dateValue"
              @change="timechange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </div>
        </el-col>

        <el-col :span="4" v-if="canLook == 1 && tabIndex != 5">
          <a class="aaaa" :href="exportUrl + '&time=' + JSON.stringify(queryInfo.time) + '&status=' + queryInfo.status + '&order_id=' + queryInfo.query + '&agencyName=' + queryInfo.agencyName">
            <el-button size="mini" type="info">导出订单</el-button>
          </a>
        </el-col>
      </el-row>

      <!-- 订单列表数据 -->
      <el-table id="out-table" :data="orderlist" border stripe ref="multipleTable" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange">
        <el-table-column type="index" :key="Math.random()"></el-table-column>
      
        <!-- <el-table-column type="selection" width="55" fixed :key="Math.random()"> </el-table-column> -->
        <el-table-column label="id号" prop="id" width="90px" :key="Math.random()"></el-table-column>
        <el-table-column label="家长姓名" prop="name" width="80px" :key="Math.random()"></el-table-column>
        <el-table-column label="学生姓名" prop="s_name" width="70px" :key="Math.random()"></el-table-column>
        <el-table-column label="电话" prop="phone" width="110px" :key="Math.random()"></el-table-column>
        <el-table-column label="日期信息" prop="title" align="center" width="200px" :key="Math.random()"> </el-table-column>
        <el-table-column label="座位" prop="s_id" align="center" width="60px" :key="Math.random()"> </el-table-column>
     <el-table-column label="时间" prop="create_at" width="140px"> </el-table-column>
     
        
        <el-table-column label="状态" width="140px" :key="Math.random()">
          
          <!-- 全部-1 待使用0 已过期1 ,已取消2 -->
          <template slot-scope="scope">
            <el-tag type="primary" v-if="scope.row.status == '0'">待使用</el-tag>
            <el-tag class="daiqueren" v-if="scope.row.status == '1'">已过期</el-tag> 
            <el-tag type="info" v-if="scope.row.status == '2'">已取消</el-tag> 
          </template>
        </el-table-column>

   
        <!-- <el-table-column label="操作" width="360px" v-if="canLook == 1" :key="Math.random()">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" v-if="scope.row.order_status == 1" @click="clickSureOrder(scope.row.order_id)">确认</el-button>
            <el-button size="mini" type="danger" v-if="scope.row.order_status == 1" @click="cancelOrder(scope.row.order_id)">删除</el-button>
            <el-button size="mini" type="primary" v-if="tabIndex < 5" @click="editOrder(scope.row.order_id)">编辑</el-button>
            <el-button size="mini" type="success" v-if="scope.row.order_status == 2 || scope.row.order_status == 3 || scope.row.order_status == 4" @click="clickEditQuyuOrder(scope.row.order_id,scope.row.buType)">区域编辑</el-button>
            <el-button size="mini" style="margin-left:10px;" type="primary" v-if="scope.row.order_status == 3" @click="completeOneOrder(scope.row.order_id)">完成</el-button>
          </template>
        </el-table-column>
         -->
      </el-table>

  
      <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[10, 20, 30]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>

    <!-- 确认订单 -->
    <!-- <el-dialog title="确认订单" :visible.sync="sureOrderDialogVisible" width="50%" @close="sureOrderDialogClosed">
      <el-form :model="buTypeForm" label-width="130px">
        <el-form-item label="地区">
          <el-radio v-model="radio" label="1">埠内</el-radio>
          <el-radio v-model="radio" label="2">埠外</el-radio>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="sureOrderDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="sureOrder">确 定</el-button>
      </span>
    </el-dialog> -->

  

    <!-- 订单取消的对话框 -->
    <el-dialog title="删除订单" :visible.sync="cancelVisible" width="50%" @close="cancelDialogClosed">
      <el-form :model="cancelForm" :rules="cancelFormRule" ref="cancelFormRef" label-width="100px">
        <el-form-item label="删除原因" prop="cancelSeasion">
          <el-input v-model="cancelForm.cancelSeasion"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelVisible = false">取消操作</el-button>
        <el-button type="primary" @click="cancelOrderClick">确定删除</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

export default {
  data () {
    return {
      dateValue:null, 
      canLook: 1,
      exportUrl: 'https://hsapi.hsxsn.cn/exportExcel?&mPhone=' + localStorage.getItem('phone'),
      queryInfo: { 
        name: '',
        s_name: '',
        time: null,
        status: -1, 
        pagenum: 1,
        pagesize: 10
      },
      statusValue: '全部',
      statusOptions: [
      // 0待使用，1已到期，2已取消
        { value: '全部', id: -1 },
        { value: '待使用', id: 0 }, 
        { value: '已过期', id: 1 }, 
        { value: '已取消', id: 2 },
      ],
      
      total: 0,
      orderlist: [],
   
      cancelForm: {
        cancelSeasion: null,
      },

      cancelVisible: false,
      cancelFormRule: {
        cancelSeasion: [
          { required: true, message: '取消理由不能为空', trigger: 'blur' }
        ],
      },

      selectOrderId: null,
      sureOrderDialogVisible: false,
      multipleSelection: [],
      multipleSelectionjson: null,
      tabIndex: 0
    }
  },

  created () {
    this.getOrderList()
  },

  methods: {

    cancelDialogClosed () {
      this.cancelVisible = false
    },

    cancelOrder (id) {
      this.selectOrderId = id;
      this.cancelVisible = true
    },

    // 取消订单
    async cancelOrderClick () {
      this.$refs.cancelFormRef.validate(async valid => {
        if (!valid) return
        const { data: res } = await this.$http.post('admin/order/cancelOrderInfo',
          {
            order_id: this.selectOrderId,
            cancelSeasion: this.cancelForm.cancelSeasion,
          })
        if (res.code !== 200) {
          return this.$message.error('操作失败！')
        }
        this.cancelVisible = false
        this.cancelForm.cancelSeasion=null
        this.getOrderList()
      })
    },

    handleClick (tab, event) {
      console.log(tab.index);
      this.tabIndex = tab.index;
      this.queryInfo.status = tab.index-1
      this.filterSelect();
    },

    // 编辑
    editOrder (id) {
      console.log(id);
      this.$router.push({ path: '/orders/detail', query: { id: id ,show:1} })
    },

    // 删除
    async deleteOrder (id) {
      const confirmResult = await this.$confirm(
        '订单删除后将不可找回,是否继续?',
        '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }
      ).catch(err => err)
      if (confirmResult !== 'confirm') {
        return this.$message.info('取消操作！')
      }
      const { data: res } = await this.$http.post('admin/order/delete', {
        id: id,
      })
      if (res.code !== 200) {
        return this.$message.error('删除订单失败！')
      }
      this.$message.success('删除订单成功！')
      this.getOrderList()
    },

    //搜索
    search () {
      this.total = 0
      this.queryInfo.pagenum = 1 
      this.orderlist = []
      this.getOrderList()
    },

    timechange () {
      this.filterSelect();
    },

    filterSelect () {
      this.total = 0
      this.queryInfo.pagenum = 1
      if (this.dateValue) {
        this.queryInfo.startTime = this.formaData(this.dateValue[0]);
        this.queryInfo.endTime = this.formaData(this.dateValue[1]);
      }else{
        this.queryInfo.startTime =null
        this.queryInfo.endTime =null
      }
      this.orderlist = []
      this.getOrderList()
    },
     // 定义格式化封装函数
     formaData(timer) {
      const year = timer.getFullYear();
      const month = timer.getMonth() + 1; // 由于月份从0开始，因此需加1
      const day = timer.getDate();
      return `${this.pad(year, 4)}-${this.pad(month)}-${this.pad(day)}`;
    },
    // 定义具体处理标准
    // timeEl 传递过来具体的数值：年月日时分秒
    // total 字符串总长度 默认值为2
    // str 补充元素 默认值为"0"
    pad(timeEl, total = 2, str = "0") {
      return timeEl.toString().padStart(total, str);
    },
    // 多选选择的项
    handleSelectionChange (val) {

      this.multipleSelection = val;
      var list = [];
      val.forEach(element => {
        list.push({ 'id': element.id });
      });
      console.log(list)
      if (list.length > 0) {
        this.multipleSelectionjson = JSON.stringify(list);
        this.exportUrl = 'https://hsapi.hsxsn.cn/exportExcel?data=' + this.multipleSelectionjson + '&mPhone=' + localStorage.getItem('phone')
      } else {
        this.multipleSelectionjson = null;
        this.exportUrl = 'https://hsapi.hsxsn.cn/exportExcel?&mPhone=' + localStorage.getItem('phone')
      }
    },


    //点击确认定点杆
    clickSureOrder (id) {
      this.selectOrderId = id;
      this.sureOrderDialogVisible = true;
    },

    // 确认订单 确认1 ,发货2,已完成3, 取消6
    async sureOrder () {
      // console.log(this.radio);
      // if (this.radio == 0) {
      //   return this.$message.error('请选择地区！')
      // }
      // const { data: res } = await this.$http.post('admin/order/sureOrdersStatus', {
      //   id: this.selectOrderId,
      //   buType: this.radio
      // })
      // this.radio = 0
      // if (res.code !== 200) {

      //   return this.$message.error('确认订单失败！')
      // }
      // this.$message.success('确认订单成功！')
      // this.getOrderList()
      // this.sureOrderDialogVisible = false;
    },

    sendOrder (id) {
      this.sendOrderId = id
      this.sendVisible = true
    },

    sendDialogClosed () {
      this.$refs.sendFormRef.resetFields()
    },

    sureOrderDialogClosed () {
      // this.radio = 0
      // this.$refs.sendFormRef.resetFields()
    },

    // 发货订单
    async sendVisibleSure () {
      this.$refs.sendFormRef.validate(async valid => {
        if (!valid) return
        const { data: res } = await this.$http.post('admin/order/sendOrdersById', {
          order_id: this.sendOrderId,
          sendName: this.sendForm.sendName,
          sendPhone: this.sendForm.sendPhone,
        })
        if (res.code !== 200) {
          return this.$message.error(res.message)
        }
        this.$message.success('订单发货成功！')
        this.sendVisible = false
        this.getOrderList()
      })
    },

    // 批量发货订单
    async sendOrder1 () {
      if (this.multipleSelection == null || this.multipleSelection.length == 0) {
        return this.$message.info('请先勾选订单！')
      }
      const confirmResult = await this.$confirm(
        '将发货所有已选中的已确认订单，其余订单发货无效, 是否继续?',
        '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }
      ).catch(err => err)
      if (confirmResult !== 'confirm') {
        return this.$message.info('取消操作！')
      }
      const { data: res } = await this.$http.post('admin/order/changeOrdersStatus', {
        data: this.multipleSelection,
        type: 2,
      })
      if (res.code !== 200) {
        return this.$message.error('订单发货失败！')
      }
      this.$message.success('订单发货成功！')
      this.getOrderList()
    },

    // 批量完成订单
    async completeOrder () {
      if (this.multipleSelection == null || this.multipleSelection.length == 0) {
        return this.$message.info('请先勾选订单！')
      }
      const confirmResult = await this.$confirm(
        '将所有已选中的已发货订单，其余订单完成无效, 是否继续?',
        '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }
      ).catch(err => err)
      if (confirmResult !== 'confirm') {
        return this.$message.info('取消操作！')
      }
      const { data: res } = await this.$http.post('admin/order/changeOrdersStatus', {
        data: this.multipleSelection,
        type: 3,
      })
      if (res.code !== 200) {
        return this.$message.error('订单已完成操作失败！')
      }
      this.$message.success('订单已完成操作成功！')
      this.getOrderList()
    },

    // 完成单个订单
    async completeOneOrder (id) {
      const confirmResult = await this.$confirm(
        '将订单置为已完成状态, 是否继续?',
        '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }
      ).catch(err => err)
      if (confirmResult !== 'confirm') {
        return this.$message.info('取消操作！')
      }
      const { data: res } = await this.$http.post('admin/order/completeOrder', {
        order_id: id,
      })
      if (res.code !== 200) {
        return this.$message.error('订单已完成操作失败！')
      }
      this.$message.success('订单已完成操作成功！')
      this.getOrderList()
    },

    async getOrderList () {
       if (window.sessionStorage.getItem('pathCanLook') == 2) { //仅查看
        this.canLook = 2
      }
      const { data: res } = await this.$http.get('admin/orderList/getList', {
        params: this.queryInfo
      })
      if (res.code !== 200) {
        return this.$message.error('暂无预约信息！')
      }
      console.log(res)
      this.total = res.result.count
      this.orderlist = res.result.list
    },

    exportOrder (order_id) {
      localStorage.setItem("kuncun_order_id", order_id);
    },

    handleSizeChange (newSize) {
      this.queryInfo.pagesize = newSize
      this.getOrderList()
    },
    handleCurrentChange (newPage) {
      this.queryInfo.pagenum = newPage
      this.getOrderList()
    },

  }
}
</script>

<style lang="less" scoped>
.el-cascader {
  width: 100%;
}
.el-table .cell {
  white-space: pre-line;
}
.el-row {
  margin-top: 10px;
}

.daiqueren {
  background-color: rgb(215, 239, 231);
}

.daifahuo {
  background-color: rgb(242, 255, 127);
}
.yifahuo {
  background-color: rgb(8, 27, 133);
}

.aaaa {
  margin-left: 10px;
}

.daochuA {
  width: 60px;
  height: 24px;
  line-height: 24px;
  align-items: center;
  background-color: blue;
  color: #fff;
  align-content: center;
  margin-left: 20px;
  display: inline-block;
  padding: 20rpx;
  font-size: 14px;
  text-decoration: none;
}
</style>
